<!-- FÓKUSZ téma: a NAPLO fejlécének párja – sötét sáv, főmenük lenyíló csempékkel, ügyfél, profil. -->
<ion-header class="b-fej" *ngIf="fokusz; else klasszikusFej">
  <div class="b-sav">
    <ion-menu-button class="b-hamb csak-mobil" title="Profil, intézmény- és modulváltás"></ion-menu-button>
    <button class="b-marka" type="button" (click)="open('/ber/fomenu')" title="Főmenü">
      <img class="b-logo" [src]="modIkon" alt="">
      <span class="b-marka-szoveg">{{ alrendszerNev }}</span>
    </button>
    <nav class="b-fomenu">
      <button *ngFor="let m of lathatoMenuk" type="button" [class.nyitva]="nyitottMenu === m.f.kulcs" [class.aktiv]="aktivFomenu === m.f.kulcs"
              (click)="menuValt(m.f.kulcs, $event)" [title]="m.f.cim + ' (' + modBill + m.f.bill.toUpperCase() + ')'">
        <ion-icon [name]="m.f.ikon"></ion-icon>
        <span>{{ cimReszek(m.f)[0] }}<u>{{ cimReszek(m.f)[1] }}</u>{{ cimReszek(m.f)[2] }}</span>
        <ion-icon class="b-nyil" name="chevron-down"></ion-icon>
      </button>
    </nav>
    <div class="b-ter"></div>
    <button class="b-ugyfel" type="button" (click)="open('/ber/ugyfelek')" title="Ügyfél választása">
      <span class="b-mod" *ngIf="aktiv.ugyfelId" title="Adózási forma">{{ aktiv.adozas || (aktiv.kivas ? 'KIVA' : 'TAO') }}</span>
      <span class="b-ugyfel-nev">{{ aktiv.ugyfelNev || 'Válassz ügyfelet' }}</span>
      <span class="b-ho">{{ honapNev(aktiv.ho) }} {{ aktiv.ev }}</span>
      <ion-icon name="swap-horizontal-outline"></ion-icon>
    </button>
    <app-profil-menu class="csak-asztal"></app-profil-menu>
  </div>
  <div class="b-lenyilo" *ngIf="nyitottMenu">
    <div class="b-lenyilo-belso">
      <button *ngFor="let p of lenyiloPontok" type="button" class="b-csempe" [class.aktiv]="aktivPont === p.kulcs" (click)="nyit(p)">
        <span class="b-csempe-ikon"><ion-icon [name]="p.ikon"></ion-icon></span>
        <span class="b-csempe-cim">{{ p.cim }}</span>
        <span class="b-csempe-leiras">{{ p.leiras }}</span>
      </button>
    </div>
  </div>
</ion-header>
<div class="b-fatyol" *ngIf="nyitottMenu" (click)="nyitottMenu = null"></div>

<!-- KLASSZIKUS téma: a régi eszköztár (a menüt a bal sáv adja). -->
<ng-template #klasszikusFej>
  <ion-header [translucent]="true">
    <ion-toolbar class="ber-toolbar">
      <ion-buttons slot="start"><ion-menu-button></ion-menu-button></ion-buttons>
      <ion-title>
        <span class="ber-cim" (click)="open('/ber/fomenu')" style="cursor:pointer" title="Főmenü">
          <img class="ber-ikon" [src]="modIkon" alt="">
          <span style="opacity:.7; font-weight:400">{{ alrendszerNev }} ·</span> {{ oldalCim() }}
        </span>
      </ion-title>
      <ion-buttons slot="end">
        <ion-chip class="ber-aktiv" outline (click)="open('/ber/ugyfelek')">
          <ion-icon name="business"></ion-icon>
          <ion-label>{{ aktiv.ugyfelNev || 'Nincs kiválasztott ügyfél' }}</ion-label>
          <ion-badge color="light">{{ honapNev(aktiv.ho) }} {{ aktiv.ev }}</ion-badge>
        </ion-chip>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
</ng-template>

<ion-content class="b-tartalom">
  <router-outlet></router-outlet>
</ion-content>
